<template>
  <section :style="isMobile ? '' : 'width: 75%; margin: auto;'">
    <h1>Painel de Controle</h1>
    <v-row style="margin-top: 10px">
      <v-col cols="12" md="6" style="padding: 5px">
        <div style="padding: 10px 20px 20px 20px; border-radius: 10px;">
          <h2 style="margin-bottom: 10px; display: flex; flex-direction: row; align-items: center"><v-icon style="margin-right: 10px" color="primary" size="small">mdi-chart-bar</v-icon>Indicadores Gerais</h2>
          <v-row>
            <v-col
              v-for="(dashboard, i) in dados"
              :key="i"
              cols="12"
              sm="6"
            >
              <WidgetFive
                :color="dashboard.color"
                :earn="dashboard.earn"
                :icon="dashboard.icon"
                :name="dashboard.name"
                :loading="loading"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12" md="6" style="padding: 5px">
        <div style="padding: 10px 20px 20px 20px; border-radius: 10px;">
          <h2 style="margin-bottom: 10px; display: flex; flex-direction: row; align-items: center"><v-icon color="green" size="10px" style="margin-right: 10px">mdi-circle</v-icon>Últimas Vaquejadas</h2>
          <div style="border: 1px solid #e0e0e0; border-radius: 10px; padding: 5px; display: flex; flex-direction: column; justify-content: center; align-items: center">
            <v-list width="100%" rounded v-for="(v, index) in vaquejadas" :key="index">
              <v-list-item density="compact" @click="$router.push(`/vaquejadas/${v.id}`)">
                <template #title>
                  {{ v.nome }}
                </template>
                <template #subtitle>
                  {{ v.dataInicio.split('T')[0].split('-').reverse().join('/') }}{{ v.diasSenhas.length > 1 ? ' - ' + v.dataFim.split('T')[0].split('-').reverse().join('/') : '' }}
                </template>
                <template #append>
                  <v-chip variant="elevated" color="yellow"><v-icon>mdi-arrow-right</v-icon></v-chip>
                  <!--v-chip variant="elevated" color="yellow">{{ getQuantidadeTempoPassado(v.dataHoraEncerramento) }}</--v-chip-->
                </template>
              </v-list-item>
              <v-divider v-if="index !== 3" style="margin-top: 5px" />
            </v-list>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row style="margin-top: 50px; margin-bottom: 20px">
      <v-col cols="12" sm="6">
        <v-card elevation="5">
          <v-card color="primary" variant="outlined" @click="$router.push('/vaquejadas')">
            <v-card-text>
              <div class="d-flex align-items-center justify-space-between">
                <div class="grid-actions">
                  <div class="grid-actions-icon">
                    <v-icon icon="mdi-horse" />
                  </div>
                  <div class="grid-actions-title">
                    <h6 class="text-h6 text-lightText mb-1">Vaquejadas</h6>
                  </div>
                  <div class="grid-actions-icon-end">
                    <v-icon icon="mdi-arrow-right" />
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card elevation="5">
          <v-card color="success" variant="outlined" @click="$router.push('/vaqueiros')">
            <v-card-text>
              <div class="d-flex align-items-center justify-space-between">
                <div class="grid-actions">
                  <div class="grid-actions-icon">
                    <v-icon icon="mdi-horse-human" />
                  </div>
                  <div class="grid-actions-title">
                    <h6 class="text-h6 text-lightText mb-1">Vaqueiros</h6>
                  </div>
                  <div class="grid-actions-icon-end">
                    <v-icon icon="mdi-arrow-right" />
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card elevation="5">
          <v-card color="warning" variant="outlined" @click="$router.push('/cidades')">
            <v-card-text>
              <div class="d-flex align-items-center justify-space-between">
                <div class="grid-actions">
                  <div class="grid-actions-icon">
                    <v-icon icon="mdi-city" />
                  </div>
                  <div class="grid-actions-title">
                    <h6 class="text-h6 text-lightText mb-1">Cidades</h6>
                  </div>
                  <div class="grid-actions-icon-end">
                    <v-icon icon="mdi-arrow-right" />
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card elevation="5">
          <v-card color="purple" variant="outlined" @click="$router.push('/categorias')">
            <v-card-text>
              <div class="d-flex align-items-center justify-space-between">
                <div class="grid-actions">
                  <div class="grid-actions-icon">
                    <v-icon icon="mdi-view-list" />
                  </div>
                  <div class="grid-actions-title">
                    <h6 class="text-h6 text-lightText mb-1">Categorias</h6>
                  </div>
                  <div class="grid-actions-icon-end">
                    <v-icon icon="mdi-arrow-right" />
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card elevation="5">
          <v-card color="red" variant="outlined" @click="$router.push('/admins')">
            <v-card-text>
              <div class="d-flex align-items-center justify-space-between">
                <div class="grid-actions">
                  <div class="grid-actions-icon">
                    <v-icon icon="mdi-account-group" />
                  </div>
                  <div class="grid-actions-title">
                    <h6 class="text-h6 text-lightText mb-1">Administradores</h6>
                  </div>
                  <div class="grid-actions-icon-end">
                    <v-icon icon="mdi-arrow-right" />
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script>
  import WidgetFive from '@/components/MainPage/WidgetFive.vue'
  import dayjs from 'dayjs';
  import utc from 'dayjs/plugin/utc.js';
  import timezone from 'dayjs/plugin/timezone.js';
  export default {
    name: 'Dashboard',
    components: { WidgetFive },
    data: () => ({
      dados: [
        {
          name: 'Vaquejadas',
          earn: '',
          color: 'yellow',
          icon: 'mdi-horse',
        },
        {
          name: 'Vaqueiros',
          earn: '',
          color: 'yellow',
          icon: 'mdi-horse-human',
        },
        {
          name: 'Vendas',
          earn: '',
          color: 'yellow',
          icon: 'mdi-currency-usd',
        },
        {
          name: 'Cidades',
          earn: '',
          color: 'yellow',
          icon: 'mdi-city',
        },
      ],
      loading: false,
      vaquejadas: [],
    }),
    computed: {
      isMobile() {
        return this.$vuetify.display.mobile;
      }
    },
    async created() {
      await this.list();
      try {
        this.loading = true;
        const response = await this.axios.get(`counters`);
        if (response.status === 200) {
          this.dados[0].earn = String(response.data.vaquejadas);
          this.dados[1].earn = String(response.data.vaqueiros);
          this.dados[2].earn = String(response.data.vendas);
          this.dados[3].earn = String(response.data.cidades);
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    methods: {
      async list() {
        try {
          const response = await this.axios.get('vaquejadas', {
            params: {
              includeCity: 'true',
              onlyNoActives: 'true',
              feed: 'true'
            },
          });

          this.vaquejadas = response.data.vaquejadas.slice(0, 4);
        } catch (e) {
          console.error(e);
        }
      },
      getQuantidadeTempoPassado(datahora) {
        dayjs.extend(utc);
        dayjs.extend(timezone);

        const agora = dayjs().tz("America/Sao_Paulo");
        const data = dayjs(datahora).tz("America/Sao_Paulo");
        const diffMinutos = agora.diff(data, 'minute');

        if (diffMinutos < 60) {
          return `há ${String(diffMinutos).padStart(2, '0')} minuto${diffMinutos !== 1 ? 's' : ''} atrás`;
        }

        const diffHoras = Math.floor(diffMinutos / 60);
        if (diffHoras < 24) {
          return `há ${String(diffHoras).padStart(2, '0')} hora${diffHoras !== 1 ? 's' : ''} atrás`;
        }

        const diffDias = Math.floor(diffHoras / 24);
        if (diffDias < 30) {
          return `há ${String(diffDias).padStart(2, '0')} dia${diffDias !== 1 ? 's' : ''} atrás`;
        }

        const diffMeses = Math.floor(diffDias / 30);
        return `há ${String(diffMeses).padStart(2, '0')} mês${diffMeses !== 1 ? 'es' : ''} atrás`;
      }
    }
  }
</script>

<style scoped>
.grid-actions {
  display: flex;
  align-items: center;
  width: 100%;
}

.grid-actions-icon {
  width: 20%;
}

.grid-actions-title {
  width: 60%;
}

.grid-actions-icon-end {
  width: 20%;
  text-align: right;
}
</style>
